import { CSSProperties, useMemo } from 'react';
import { UploaderListView } from './uploader-list/uploader-list.view';
import { IDataPackageFileDescriptor, IUploader } from '@vivli/shared/features/data-package/infrastructure/interface';
import { DataPackageTypeEnum } from '@vivli/features/studies/infrastructure/enum';
import { FileUploaderView } from './file-uploader.view';

const containerStyle: CSSProperties = {
    boxShadow: '0px 0px 5px 0px rgba(255,255,255,0.65)',
    padding: '5px',
    backgroundColor: 'rgba(255,255,255,0.65)'
};

interface UploaderViewProps extends IUploader {
    files?: IDataPackageFileDescriptor[];
    preExistingFiles?: IDataPackageFileDescriptor[];
    isLoading?: boolean;
    scrollEnabled?: boolean;
    packageType?: DataPackageTypeEnum;
    readonly?: boolean;
    secondaryFilesToShow?: IDataPackageFileDescriptor[];
    hybridMode?: boolean;
}

export const UploaderView = (props: UploaderViewProps) => {
    const { fileLimitReached, allowUpload } = props;

    //Single source of truth for "the file uploader is visible" - gates the drop zone so users without
    //upload rights never see it. (DEV-488)
    const showUploader = useMemo(() => !fileLimitReached && !!allowUpload, [fileLimitReached, allowUpload]);

    return (
        <div style={containerStyle}>
            <div>
                <FileUploaderView {...props} showUploader={showUploader}>
                    <UploaderListView {...props} />
                </FileUploaderView>
            </div>
        </div>
    );
};
